<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-row>
        <d-col md="6" class="form-group">
          <d-form>
            <d-card class="card-small">
              <d-card-header class="border-bottom">
                <h6 class="m-0">Segmentos</h6>
              </d-card-header>

              <d-card-body class="p-0 pb-1">
                <d-list-group>
                  <d-list-group-item v-for="(row, index) in drives" :key="index" class="d-flex px-3 drive-row">
                    <span class="text-semibold text-fiord-blue col pl-0">
                      <d-input
                        v-model="row.name"
                        class="input-hidden"
                        placeholder="Adicione um segmento"
                        @change="capitalizeInput(index)"
                      />
                    </span>
                    <span class="ml-auto text-right text-semibold col-auto px-0">
                      <i class="fas fa-plus" @click="addRow()" v-if="index + 1 === drives.length"></i>
                      <i class="fas fa-minus" @click="removeRow(index)"></i>
                      <i class="fas fa-save" @click="saveDrive(index)"></i>
                    </span>
                  </d-list-group-item>
                </d-list-group>
              </d-card-body>
            </d-card>
          </d-form>
        </d-col>
      </d-row>
    </d-list-group-item>
    <confirmation-modal
      :cancel="closeConfirm"
      :confirm="onConfirm"
      :title="confirmation.title"
      :message="confirmation.message"
    />
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import { stringfy, capitalize } from '_utils/string';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import QuotationService from '_services/rest/modules/quotation';
import { MODEL_DRIVE } from '_modules/quotation/components/QuotationModel';

const CONFIRMATION = {
  save: {
    title: 'Confirmar alteração',
    message: 'Tem certeza que deseja salvar as alterações deste segmento?',
    callback: 'persistDrive',
  },
  delete: {
    title: 'Confirmar exclusão',
    message: 'Tem certeza que deseja excluir este segmento? Essa ação não pode ser desfeita.',
    callback: 'deleteDrive',
  },
};

export default {
  name: 'drives-form',
  components: {
    ConfirmationModal,
  },
  data() {
    return {
      drives: [{ ...MODEL_DRIVE }],
      confirmAction: 'delete',
      selectedIndex: null,
    };
  },
  computed: {
    confirmation() {
      return CONFIRMATION[this.confirmAction] || CONFIRMATION.delete;
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'setToggle',
    ]),
    addRow() {
      this.drives.push({ ...MODEL_DRIVE });
    },
    capitalizeInput(index) {
      const name = (this.drives[index].name || '').trim();
      this.drives[index].name = name ? capitalize(name) : '';
    },
    checkEmptyOptions() {
      if (this.drives.length === 0) {
        this.drives.push({ ...MODEL_DRIVE });
      }
    },
    closeConfirm() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    driveList(response) {
      if (Array.isArray(response)) {
        return response.filter(drive => drive && drive.id);
      }
      if (response && Array.isArray(response.data)) {
        return response.data.filter(drive => drive && drive.id);
      }
      return [];
    },
    loadDrives() {
      QuotationService.getDrivesOptions()
        .then(response => {
          const list = this.driveList(response).map(drive => ({
            id: drive.id,
            name: drive.name,
            slug: drive.slug,
          }));
          this.drives = list.length ? list : [{ ...MODEL_DRIVE }];
          this.syncStore();
        })
        .catch(error => {
          this.activeAlert({
            message: `${error.message} <br/> ${error.data}`,
            theme: 'danger',
          });
        });
    },
    onConfirm() {
      const index = this.selectedIndex;
      const { callback } = this.confirmation;
      this.closeConfirm();
      this[callback](index);
    },
    openConfirm(action, index) {
      this.confirmAction = action;
      this.selectedIndex = index;
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    payload(row) {
      const drive = {
        name: row.name,
        slug: row.slug,
      };
      if (row.id) drive.id = row.id;
      return drive;
    },
    deleteDrive(index) {
      const drive = this.drives[index];
      if (!drive) return;
      if (!drive.id) {
        this.drives.splice(index, 1);
        this.checkEmptyOptions();
        return;
      }
      QuotationService.deleteDrives(drive.id)
        .then(() => {
          this.drives.splice(index, 1);
          this.checkEmptyOptions();
          this.syncStore();
          this.activeAlert({ message: 'Segmento removido com sucesso', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({
            message: `${error.message} <br/> ${error.data}`,
            theme: 'danger',
          });
        });
    },
    removeRow(index) {
      const drive = this.drives[index];
      if (!drive.id && !(drive.name || '').trim()) {
        this.drives.splice(index, 1);
        this.checkEmptyOptions();
        return;
      }
      this.openConfirm('delete', index);
    },
    saveDrive(index) {
      const row = this.drives[index];
      if (!(row.name || '').trim()) {
        this.activeAlert({ message: 'Informe o nome do segmento', theme: 'warning' });
        return;
      }
      if (row.id) {
        this.openConfirm('save', index);
        return;
      }
      this.persistDrive(index);
    },
    persistDrive(index) {
      this.capitalizeInput(index);
      const row = this.drives[index];
      if (!row.name) return;
      row.slug = stringfy(row.name);
      QuotationService.saveDrives(this.payload(row))
        .then(() => {
          this.loadDrives();
          this.activeAlert({ message: 'Segmento salvo com sucesso', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({
            message: `${error.message} <br/> ${error.data}`,
            theme: 'danger',
          });
        });
    },
    syncStore() {
      this.$store.commit('setDrives', this.drives.filter(drive => drive.id));
    },
  },
  mounted() {
    this.loadDrives();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.drive-row {
  border-width: 0;
  border-bottom: 1px solid $border-color;
  margin-bottom: 0;
}

.input-hidden {
  width: 100%;
  border: 0;
  padding: 0;
  color: #3D5170;
  font-weight: 400;
  font-size: 15px;
  &:focus {
    box-shadow: none;
    border: 0;
  }
}

.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover {
    color: $green;
  }
  &.fa-minus:hover {
    color: $red;
  }
  &.fa-save:hover {
    color: $blue;
  }
}
</style>
